module.exports = __webpack_public_path__ + "static/img/UTM老师_丁然.6ff7ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTM/UTM老师_丁然.png
// module id = 1jeH
// module chunks = 0